import type { DeliveryGroupDraft } from './deliveryGroupTypes';
import { listRealLoadingPointsForGroup } from './executionBindingHelpers';

type ApplicationRef = {
  id: number;
  internalNumber?: string | null;
  loadingAddress?: string | null;
  unloadingAddress?: string | null;
  loadingContactPerson?: string | null;
  loadingPhone?: string | null;
  unloadingContactPerson?: string | null;
  unloadingPhone?: string | null;
  consigneeId?: number | null;
  consignee?: { name?: string | null; contactPerson?: string | null; phone?: string | null; address?: string | null } | null;
};

/** Синхронизация первой группы с полями формы для patch-only сохранения (backend contract). */
export function deriveFormFieldsFromPrimaryGroup(
  group: DeliveryGroupDraft | null | undefined,
  applications: ApplicationRef[]
): Record<string, unknown> {
  if (!group) return {};
  const app = group.applicationId
    ? applications.find((a) => a.id === group.applicationId)
    : undefined;

  const firstLoading = group.loadingStops[0];
  const firstUnloading = group.unloadingStops[0];

  const patch: Record<string, unknown> = {};

  if (group.applicationId && app) {
    patch.loadingPointType = 'application';
    patch.loadingPointId = group.applicationId;
    patch.applicationId = group.applicationId;
    patch.loadingAddress = firstLoading?.address ?? app.loadingAddress ?? '';
    patch.loadingContactPerson = firstLoading?.contactPerson ?? app.loadingContactPerson ?? '';
    patch.loadingPhone = firstLoading?.phone ?? app.loadingPhone ?? '';
    patch.plannedLoadingDate = firstLoading?.plannedAt ?? undefined;
  } else if (firstLoading?.pointType === 'warehouse' && firstLoading.pointId) {
    patch.loadingPointType = 'warehouse';
    patch.loadingPointId = firstLoading.pointId;
    patch.loadingAddress = firstLoading.address ?? '';
    patch.loadingContactPerson = firstLoading.contactPerson ?? '';
    patch.loadingPhone = firstLoading.phone ?? '';
    patch.plannedLoadingDate = firstLoading.plannedAt ?? undefined;
  }

  if (firstUnloading) {
    if (firstUnloading.pointType === 'warehouse' && firstUnloading.pointId) {
      patch.unloadingPointType = 'warehouse';
      patch.unloadingPointId = firstUnloading.pointId;
    } else if (firstUnloading.pointType === 'consignee' && firstUnloading.pointId) {
      patch.unloadingPointType = 'application';
      patch.unloadingPointId = group.applicationId ?? undefined;
      patch.consigneeId = firstUnloading.pointId;
    } else if (group.applicationId) {
      patch.unloadingPointType = 'application';
      patch.unloadingPointId = group.applicationId;
    }
    patch.unloadingAddress = firstUnloading.address ?? app?.unloadingAddress ?? '';
    patch.unloadingContactPerson =
      firstUnloading.contactPerson ?? app?.unloadingContactPerson ?? app?.consignee?.contactPerson ?? '';
    patch.unloadingPhone = firstUnloading.phone ?? app?.unloadingPhone ?? app?.consignee?.phone ?? '';
    patch.plannedUnloadingDate = firstUnloading.plannedAt ?? undefined;
  } else if (app) {
    patch.unloadingPointType = 'application';
    patch.unloadingPointId = group.applicationId;
    patch.unloadingAddress = app.unloadingAddress ?? '';
    patch.unloadingContactPerson = app.unloadingContactPerson ?? app.consignee?.contactPerson ?? '';
    patch.unloadingPhone = app.unloadingPhone ?? app.consignee?.phone ?? '';
    patch.consigneeId = app.consigneeId ?? undefined;
  }

  return patch;
}

export type LoadingPointOption = {
  key: string;
  position: number;
  label: string;
};

/** @deprecated use listRealLoadingPointsForGroup */
export function listLoadingPointsForGroup(
  group: DeliveryGroupDraft,
  _params?: { mainLoadingLabel?: string }
): LoadingPointOption[] {
  return listRealLoadingPointsForGroup(group).map((p) => ({
    key: p.key,
    position: p.position,
    label: p.label
  }));
}
